<script>
import Loader from "@/components/widgets/loader";
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import StrRisklerGirislerCevap from "@/models/StrRisklerGirislerCevap";
import EylemEdit from "./EylemEdit"

import store from "@/state/store"; 
export default {
  mixins: [Api, Sabit, StrRisklerGirislerCevap], 
  props: ["RiskId","BirimId","AltDonemId","Risk","Index","KontrolTrue","AltDonemAktif"],
  data() {
    return {
      Page: {
        PageNumber: "1",
        PageSize: "9999",
        PageDataSize: "1",
      },
      TableData: {},
      KontrolData: {},
      FormData: {},
      OnayFormData: {},
      KontrolAciklama: null,
      KullaniciBilgileri: [],
      RoleKontrol: false,
      AltDonemAciklama: "", 

    };
  },
  components: {
    Loader,
    EylemEdit,
 
  },
  watch: {
    
    KontrolTrue() {

      this.Get();
    },
  
  },

  methods: {
    onSubmit() {

    },
    BirimEylemOnay(){
      this.$emit("Onay");
    },
    BirimEylemOnayKaldir(){
      this.$emit("OnayKaldir");
    },
    OnayKaldir(){
      this.Get();
      for(var DATA in this.AllKontrolData){
        this.OnayFormData = null
        for(var Data2 in this.AllKontrolData[DATA]){
        this.OnayFormData = this.AllKontrolData[DATA][Data2]
        this.OnayFormData.Onay = 0;
        this.Update("StrRisklerGirislerCevap", this.OnayFormData, false);

      }
      this.$emit("TableUpdate");
      }
    },
    Get() {

        let Filter = "&DonemId=" + this.AltDonemId +"&RiskId=" + this.RiskId +"&BirimId=" + this.BirimId;
        this.ActionsFilterGet({ Service: "StrRiskGiris", Page: this.Page, Filter: Filter }).then((res) => {
          this.TableData = res.Data[0];
          this.Page.PageDataSize = res.TotalCount;
          this.KontrolGet(this.TableData)
        });
    },
    KontrolGet(Data){
      this.ActionsFilterGet({Service:"StrRisklerGirislerCevap", Page:this.Page,Filter: "&BirimId=" +this.BirimId + "&GirisId=" + Data.Id + "&CevapTipi=" + Data.Kontrolturu}).then((res) => {
            this.KontrolData = res.Data;

                  }); 
                
            
    },
    StrKontrolUpdate(){
      this.$emit("AllKontrolGet");
    }
    


  },
  created() {

  this.Userid = store.getters.["auth/TokenUserId"] 
  this.UserEmail = store.getters.["auth/UserEMail"] 
  this.KullaniciBilgileri = store.getters.["auth/UserRolles"];
  let Page= {
        PageNumber: "1",
        PageSize: "9999"
      }
  this.ActionsFilterGet({
        Service: this.$config.API_ACCOUNT_URL + "Account/get-userroles",
        Page: Page,
        Filter: "&email=" + this.UserEmail,
      }).then((res) => {
        let YetkiSorgu = res.Data.Roles.filter((item) =>
        item.includes("StrPerformansGirisOnay")
      );
      if (YetkiSorgu.length != 0){
        this.RoleKontrol = true; 
      } 

      });

      this.ActionsSingleGet({
                Service: "strperfdonem",
                Id: this.AltDonemId,
              }).then((res) => {
                this.AltDonemAciklama = res.Data.Aciklama;

      });




},
};
</script>
<template>
  <Loader>   
    <table class="table table-striped table-bordered mb-0"  v-if="Object.keys(KontrolData).length > 0">
                    <thead>
                      <tr>
                        <th>
                        Eylem 
                      </th>
                      <th style="text-align: center;">
                       <div class="col-12">
                        {{ AltDonemAciklama }}
                       </div> 
                        İşlem 
                        <b-button variant="success" v-if="this.KontrolData[0].Onay == 0 && this.RoleKontrol && AltDonemAktif && Index == 0" @click="BirimEylemOnay()">Onay</b-button>
                        <b-button variant="danger" v-if="this.KontrolData[0].Onay == 1 && this.RoleKontrol && AltDonemAktif  && Index == 0" @click="BirimEylemOnayKaldir()">Onay Kaldır</b-button>
                      </th>
                      </tr>

                    </thead>
                    <tbody v-for="(Data, index) in this.KontrolData" :key="index">
                      <tr v-if="Data.Durum != 1">
                        <th class="col-9">{{ Data.Cevap }}</th>
                        <td>
                          <EylemEdit :KontrolVerileri="Data" 
                          @Data="$emit('FormData', $event)" @TableUpdate = "Get()" @TableUpdateKontrolData = "StrKontrolUpdate()"
                         />
                        </td>
                                            
                      </tr>
                    </tbody>
                    </table>


  </Loader>
</template>
